<template>
    <div class="table">
        <NoData v-if="!customers.length" :type="'potential-policies-table'" />
        <template v-else>
            <div class="table__header box box--default">
                <div class="table__label table__label--small">
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`customers.${"tableHeader"}.${"category"}`) }}
                </div>
                <div class="table__label table__label--large">
                    {{ $t(`customers.${"tableHeader"}.${"name"}`) }}
                </div>
                <div class="table__label table__label--medium">
                    {{ $t(`customers.${"tableHeader"}.${"contact"}`) }}
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`customers.${"tableHeader"}.${"zipCode"}`) }}
                </div>
                <div class="table__label table__label--medium">
                    {{ $t(`customers.${"tableHeader"}.${"city"}`) }}
                </div>
                <div class="table__label table__label--medium">
                    {{ $t(`customers.${"tableHeader"}.${"deadline"}`) }}
                </div>
                <div class="table__label table__label--large">
                    {{ $t(`customers.${"tableHeader"}.${"text"}`) }}
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`customers.${"tableHeader"}.${"file"}`) }}
                </div>
                <div class="table__label table__label--small">
                    {{ $t(`customers.${"tableHeader"}.${"contract"}`) }}
                </div>
                <div class="table__label table__label--small"></div>
                <div class="table__label table__label--small"></div>
            </div>

            <div class="table__body">
                <div  v-for="policy in customers" :key="policy.id">
                    <div 
                        @click="routeToCustomer(policy.customer)" 
                        class=" customer row row--hover box box--default"
                        :class="[policy.priority && policy.priority.type ? `policy--type-${policy.priority.type}` : '']"
                    >
                        <div class="row__data row__data--small policy-icon">
                            <div :class="['icon', getPolicyIconClass(policy)]"></div>
                        </div>
                        <div class="row__data row__data--name row__data--small category">
                            {{ policy.category ? policy.category.code : '----' }}
                        </div>
                        <div class="row__data row__data--name row__data--large">
                            <span v-if="policy.customer"> {{ policy.customer.first_name }} {{ policy.customer.last_name
                            }}
                            </span>
                            <span v-else> ----- </span>
                        </div>
                        <div @click.stop class="row__data row__data--contact row__data--medium">
                            <span v-if="policy.customer">
                                <a class="row__phone icon__phone"
                                    :href="getPhone(policy.customer) ? `tel:${getPhone(policy.customer)}` : 'javascript:void(0)'"
                                    :class="{ 'icon__phone--active': getPhone(policy.customer) }"></a>

                                <a class="row__mail icon__mail"
                                    :href="getEmail(policy.customer) ? `mailto:${getEmail(policy.customer)}` : 'javascript:void(0)'"
                                    :class="{ 'icon__mail--active': getEmail(policy.customer) }"></a>
                            </span>

                            <span v-else>
                                <a class="row__phone icon__phone"></a>
                                <a class="row__mail icon__mail"></a>
                            </span>
                        </div>

                        <div class="row__data row__data--zip row__data--small">
                            <template v-if="policy.customer && getFirstAddress(policy.customer)">
                                {{ getFirstAddress(policy.customer).zip || '----' }}
                            </template>
                            <template v-else>----</template>
                        </div>
                        <div class="row__data row__data--city row__data--medium">
                            <template v-if="policy.customer && getFirstAddress(policy.customer)">
                                {{ getFirstAddress(policy.customer).city || '----' }}
                            </template>
                            <template v-else>----</template>
                        </div>
                        <div class="row__data row__data--date row__data--medium">
                            {{ formatSimpleDate(policy.date) }}
                        </div>
                        <div class="row__data row__data--date row__data--large">
                            <!-- <p>{{ policy.text || '----' }}</p> -->
                            <EditableComment :comment="policy.text" :readonly="true" />
                        </div>

                        <div class="row__data row__data--small row__data--pdf icon__pdf"
                            :class="{ 'icon__pdf--active': policy.files && policy.files.length }"
                            @click.stop="openPolicyFilesModal(policy)">
                        </div>

                        <div class="row__data row__data--small row__data--contract icon__contract"
                            @click.stop="convertPotentialToPolicy(policy)">
                        </div>

                        <div v-if="$checkRolePermission('potential_policy_edit')"
                            class="row__data row__data--small row__data--edit icon__edit"
                            @click.stop="openPotentialPolicyModal(policy)">
                        </div>

                        <div @click.stop v-else style="cursor:no-drop;"
                            class="row__data row__data--small row__data--edit icon__edit">
                        </div>

                        <div v-if="$checkRolePermission('potential_policy_delete')"
                            class="row__data row__data--small row__data--delete icon__delete tool-icon"
                            :class="{ 'icon__delete--active': activeDeleteId === policy.id }" tabindex="-1"
                            @focusout="activeDeleteId = null" @click.stop="activeDeleteId = policy.id">

                            <transition name="fade">
                                <div class="delete" v-if="activeDeleteId === policy.id">
                                    <div class="delete__text">
                                        {{ $t('deleteModal.question') }} {{ $t('deleteModal.potentialPolicy') }}?
                                    </div>
                                    <div class="delete__buttons">
                                        <div class="button button--confirm" @click.stop="confirmDelete(policy.id)">
                                        </div>
                                        <div class="button button--cancel" @click.stop="activeDeleteId = null"></div>
                                    </div>
                                </div>
                            </transition>
                        </div>

                        <div v-else style="cursor:no-drop;"
                            class="row__data row__data--small row__data--delete icon__delete">
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import NoData from "@/partials/NoData";
import EditableComment from "@/partials/EditableComment";
import {
    openPotentialPolicyModal,
    convertPotentialToPolicy,
} from "@/helpers/potentialPolicyModalHelpers";
export default {
    name: "PotentialPoliciesTable.vue",

    components: {
        NoData,
        EditableComment
    },
    computed: {
        ...mapGetters([

            "loggedUser",
        ]),
    },
    props: {
        customers: {
            required: true,
            type: Array,
        },
    },

    data() {
        return {
            activeDeleteId: null,
        };
    },

    methods: {
        routeToCustomer(customer) {
            this.$router.push({
                name: "AccountDetails",
                params: {
                    entity: "customer",
                    id: customer.id,
                },
                query: {
                    tab: 5
                }
            });
        },

        async convertPotentialToPolicy(policy) {
            try {
                await convertPotentialToPolicy(this, policy);
            } catch (err) {
                console.error("convertPotentialToPolicy error:", err);
                this.$store.commit("setPolicyIsConverting", false);
                this.$store.commit("setConvertingPolicyData", {});
                this.$store.commit("setShowAddPolicyModal", false);
            }
        },

        getPolicyIconClass(policy) {
            const categoryId = policy.category?.id;
            return `icon__policy--${categoryId || 'krankenkasse'}`;
        },

        policyTypeColor(policy) {
            return policy.priority ? `type-${policy.priority.type}` : null;
        },

        formatSimpleDate(dateString) {
            if (!dateString) return '-----';

            const d = new Date(dateString);

            if (isNaN(d.getTime())) return dateString;

            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();

            return `${day}.${month}.${year}`;
        },

        getPhone(customer) {
            const phones = customer?.customer_phones;
            if (Array.isArray(phones) && phones.length > 0) {
                return phones[0].phone || phones[0].number || null;
            }
            return null;
        },

        getEmail(customer) {
            const emails = customer?.customer_emails;
            if (Array.isArray(emails) && emails.length > 0) {
                return emails[0].email || null;
            }
            return null;
        },

        getFirstAddress(customer) {
            const addresses = customer?.customer_addresses;
            return (Array.isArray(addresses) && addresses.length > 0) ? addresses[0] : null;
        },

        async confirmDelete(policyId) {
            this.activeDeleteId = null;
            try {
                await this.$store.dispatch("deletePotentialPolicy", policyId);
                this.$emit("refresh");
            } catch (err) {
                console.error(err);
            }
        },

        async openPotentialPolicyModal(policy) {
            await openPotentialPolicyModal(this, policy);
        },

        openPolicyFilesModal(policy) {
            this.$store.commit("setPolicyFileId", policy.id);
            this.$store.commit("setPolicyFiles", policy.files);
            this.$store.commit("setPolicyFilesModalIsPotential", true);
            this.$store.commit("setShowPolicyFilesModal", true);
        },
    }
};
</script>

<style scoped lang="scss">
// .comment {
//     background: var(--bg-15);
//     width: 100%;
//     min-height: 50px;
//     max-height: 50px;
//     border-radius: var(--radius-1);
//     display: flex;
//     align-items: center;
//     padding: 2px 10px;
//     position: relative;
// }

.row__data--delete {
    position: relative;

    .delete {
        position: absolute;
        z-index: 3;
        background: var(--bg-1);
        right: 30%;
        top: 50%;
        transform: translateY(-50%);
        width: 330px;
        display: flex;
        align-items: center;
        border-radius: var(--radius-1);
        border: 1px solid var(--border-2);
        padding: 10px 20px;
        box-shadow: 0px 3px 6px var(--shadow-7);

        &__text {
            line-height: 20px;
            color: var(--text-9);
        }

        &__buttons {
            display: flex;
        }

        .button {
            width: 24px;
            height: 24px;
            cursor: pointer;
            transition: all 0.3s ease;

            &--confirm {
                background: url("../assets/icons/default/confirm_icon.svg");
                margin: 0 15px;

                &:hover {
                    background: url("../assets/icons/default/confirm_hover_icon.svg");
                }
            }

            &--cancel {
                background: url("../assets/icons/default/close_icon.svg");

                &:hover {
                    background: url("../assets/icons/default/close_hover_icon.svg");
                }
            }
        }
    }
}

.table .row__phone,
.table .row__mail,
.icon__pdf,
.icon__contract,
.icon__edit,
.icon__delete {
    display: block;
    height: 25px;
    width: 25px;
}

.icon__pdf,
.icon__contract,
.icon__edit,
.icon__delete {
    height: 100%;
}

.row__data--contact span {
    display: flex;
}

.category {
    justify-content: center !important;
}
 
.table__body .customer {
    position: relative;

    &:before {
        content: "";
        position: absolute;
        z-index: 3;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 100%;
        width: 15px; 
        border-top-left-radius: var(--radius-1);
        border-bottom-left-radius: var(--radius-1);
    }
 

    &.policy--type-A {
        &:before { background: #b20202; }
        .row--hover:hover { background: #b202021a; }
    }

    &.policy--type-B {
        &:before { background: #ff5f00; }
        .row--hover:hover { background: #ff5f001a; }
    }

    &.policy--type-C {
        &:before { background: #22db8e; }
        .row--hover:hover { background: #22db8e1a; }
    }

    &.policy--type-D {
        &:before { background: #ffa400; }
        .row--hover:hover { background: #ffa4001a; }
    }
}
</style>
